import { Box, Button, Typography } from "@mui/material";
import useLoadMore from "hooks/useLoadMore";
import Header from "components/Header";
import { useNavigate } from "react-router";
import useChangelog from "../hook/useChangelog";

/**
 * Page for Changelog
 */
export default function Changelog() {
  const { changelog, loading, onLoadMore } = useChangelog();
  const navigate = useNavigate();

  const { renderNodeLoader } = useLoadMore(onLoadMore, loading);

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Header showMenu={false} />
      <Box sx={{ px: { xs: 2, md: 2.5, lg: 5 }, pt: { xs: 2, md: 2.5, lg: 3 } }}>
        <Button onClick={() => navigate(-1)} variant="custom-outlined">
          <Box>＜ 戻る</Box>
        </Button>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          flex: 1,
        }}
      >
        <Typography
          sx={{
            color: "var(--gray-700)",
            fontWeight: "medium",
            mt: 14,
            fontSize: { xs: "24px", md: "28px", lg: "31px" },
          }}
        >
          YHBB 更新ログ
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            mt: { lg: "121px", md: "80px", xs: "50px" },
            gap: 3,
          }}
        >
          {changelog.map((item) => (
            <Box key={item.id} sx={{ display: "flex", gap: 2 }}>
              <Typography
                sx={{ color: "var(--gray-700)", fontSize: { sx: "16px", md: "20px", lg: "24px" } }}
              >
                {item.sys_version_date}
              </Typography>
              <Typography
                sx={{ color: "var(--gray-700)", fontSize: { sx: "16px", md: "20px", lg: "24px" } }}
              >
                {item.sys_version_cd}
              </Typography>
              <Typography
                sx={{ color: "var(--gray-700)", fontSize: { sx: "16px", md: "20px", lg: "24px" } }}
              >
                {item.remarks}
              </Typography>
            </Box>
          ))}
          {renderNodeLoader()}
        </Box>
      </Box>
    </Box>
  );
}
